module.exports = __webpack_public_path__ + "static/media/apple.9feb49cd.png";